import DepositOverdraftSettings from "@/models/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettings";

export default class AccountDepositOverdraftSettings extends DepositOverdraftSettings {
    overridden: boolean = false;
}
